module.exports = __webpack_public_path__ + "static/media/2nd_banner_item1.87f13d94.png";